<div [formGroup]="formGroup" class="input-form">
  <div class="label" [@bounceIn]>
    <p>{{label}}</p>&nbsp;
    <span *ngIf="required === 'true'" style="color: red; font-size: large;">*</span>

    <span class="required-error-upper"
      *ngIf="subtext !== '' && required === 'true' && !inputTouched && inputType !== 'time' && formControl?.value === '' ">
      Required field
    </span>

    <span class="required-error-upper" *ngIf="inputType == 'time'&& formControl?.value === '' ">
      Required field
    </span>

    <span class="file-types" *ngIf="inputType === 'file'">
      &#8729; {{ 'PDF | JPG' }}
    </span>
  </div>

  <mat-form-field *ngIf="inputType === 'normal'" appearance="outline" [ngClass]="{'input': inputFocused}" [@fadeIn]>

    <input [id]="controlName" matInput [formControlName]="controlName" [placeholder]="hint" [type]="type"
      maxlength="{{controlName === 'PercShare' ? '3' : controlName.toLowerCase() === 'distributionage' ? '2' : '100'}}"
      (focus)="onInputFocus()" (blur)="onInputBlur()">

    <!-- Add mat-suffix conditionally for PercShare -->
    <mat-icon matSuffix *ngIf="controlName === 'PercShare' && formControl?.value !== '' && (!inputFocused && this.formControl?.value && this.formControl?.value.length > 0)"
      (keydown.enter)="clearShares()" (keydown.space)="clearShares()"
      (click)="clearShares()" class="percentage-icon">delete_forever
    </mat-icon>

    <mat-hint *ngIf="subtext !== ''" class="hints">
      {{subtext}}
    </mat-hint>
    <mat-error *ngIf="shouldShowErrors()" class="errors">
      {{ getCurrentErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="inputType === 'area'" appearance="outline" [ngClass]="{'input': inputFocused}" [@fadeIn]
    style="height: 150px;">

    <textarea [id]="controlName" matInput [formControlName]="controlName" [placeholder]="hint" cdkTextareaAutosize cdkAutosizeMinRows="6"
      cdkAutosizeMaxRows="6" (focus)="onInputFocus()" (blur)="onInputBlur()">
    </textarea>
    <mat-error *ngIf="shouldShowErrors()" class="errors">
      {{ getCurrentErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="inputType === 'select'" appearance="outline"
    [ngClass]="{'input': inputFocused, 'select-loading' : loadingOptions, 'max-160' : isTitle()}" [@fadeIn]>

    <mat-select [formControlName]="controlName" panelClass="form-select-popup" [placeholder]="hint"
      (focus)="onInputFocus()" (blur)="onInputBlur()" (selectionChange)="onSelectionChange()">

      <mat-option class="form-option" *ngFor="let arrayItem of ArrayItems" [value]="isLocalInput() ? arrayItem :
            isTitle() ? arrayItem.Title :
            isCountry() ? arrayItem.CountryName :
            isCounty() ? arrayItem.CountyName :
            isNationality() ? arrayItem.Nationality :
            isBank() || isBankBranch() ? arrayItem.ID :
            arrayItem.Description ">

        {{ isLocalInput() ? arrayItem :
        isTitle() ? arrayItem.Title :
        isCountry() ? arrayItem.CountryName :
        isCounty() ? arrayItem.CountyName :
        isNationality() ? arrayItem.Nationality :
        arrayItem.Description
        }}
      </mat-option>
    </mat-select>
    <span matSuffix *ngIf="loadingOptions" class="spinner">
      <mat-progress-spinner mode="indeterminate" diameter="22" strokeWidth="2"></mat-progress-spinner>
    </span>
    <mat-error *ngIf="shouldShowErrors()" class="errors">
      {{ getCurrentErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="inputType === 'multi-select'" appearance="outline"
    [ngClass]="{'input': inputFocused, 'select-loading' : loadingOptions}" [@fadeIn]>

    <mat-select multiple [formControlName]="controlName" style="resize: none; text-overflow: ellipsis;"
      panelClass="form-select-popup" [placeholder]="hint" (focus)="onInputFocus()" (blur)="onInputBlur()"
      (selectionChange)="onSelectionChange()">

      <mat-option class="form-option"
        [value]="isLocalInput() ? arrayItem  : controlName === 'GuardianBens' ? arrayItem.ID : arrayItem.Description "
        *ngFor="let arrayItem of ArrayItems">

        {{isLocalInput() ? arrayItem : arrayItem.Description}}
      </mat-option>
    </mat-select>
    <span matSuffix *ngIf="loadingOptions" class="spinner">
      <mat-progress-spinner mode="indeterminate" diameter="22" strokeWidth="2"></mat-progress-spinner>
    </span>
    <mat-hint *ngIf="subtext !== ''" class="hints">
      {{subtext}}
    </mat-hint>
    <mat-error *ngIf="shouldShowErrors()" class="errors">
      {{ getCurrentErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="inputType === 'auto-complete'" appearance="outline"
    [ngClass]="{'input': inputFocused, 'select-loading' : loadingOptions}" [@fadeIn]>

    <input [id]="controlName" type="text" placeholder="Type or select" matInput 
       [formControlName]="controlName" [matAutocomplete]="auto"
       (input)="filter($any($event.target).value)" 
       (focus)="onInputFocus()" (blur)="onInputBlur()">

    <mat-autocomplete requireSelection #auto="matAutocomplete" panelClass="form-select-popup">
      <mat-option *ngFor="let option of filteredArray; trackBy: trackByFn" [value]="isLocalInput() ? option :
        isTitle() ? option.Title :
        isCountry() ? option.CountryName :
        isCounty() ? option.CountyName :
        isNationality() ? option.Nationality :
        isBank() || isBankBranch() ? option.ID :
        option.Description ">
          {{ isLocalInput() ? option :
            isTitle() ? option.Title :
            isCountry() ? option.CountryName :
            isCounty() ? option.CountyName :
            isNationality() ? option.Nationality :
            option.Description
          }}
      </mat-option>
    </mat-autocomplete>

    <span matSuffix *ngIf="loadingOptions" class="spinner">
      <mat-progress-spinner mode="indeterminate" diameter="22" strokeWidth="2"></mat-progress-spinner>
    </span>
    <mat-error *ngIf="shouldShowErrors()" class="errors">
      {{ getCurrentErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="inputType === 'date'" class="date-input" appearance="outline"
    [ngClass]="{'input': inputFocused}" [@fadeIn]>
    <input [id]="controlName" *ngIf="!weekdaysOnly" matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" readonly="true"
      (click)="picker.open()" (focus)="onInputFocus()" (blur)="onInputBlur()" [placeholder]="hint"
      [formControlName]="controlName" />
    <input [id]="controlName" *ngIf="weekdaysOnly" matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker"
      [matDatepickerFilter]="dateFilter" readonly="true" (click)="picker.open()" (focus)="onInputFocus()"
      (blur)="onInputBlur()" [placeholder]="hint" [formControlName]="controlName" />
    <mat-datepicker-toggle matIconPrefix [for]="picker">
      <mat-icon matDatepickerToggleIcon style="margin-bottom: 2px !important;">event</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker> </mat-datepicker>
    <mat-error *ngIf="shouldShowErrors()" class="errors">
      {{ getCurrentErrorMessage() }}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="inputType === 'time'" class="date-input" appearance="outline"
    [ngClass]="{'input': inputFocused}" [@fadeIn]>
    <div class="time-input-wrapper">
      <input [id]="controlName" matInput [value]="time" [formControlName]="controlName" placeholder="09:00" (focus)="onInputFocus()"
        (blur)="onInputBlur()" maxlength="5" />
      <mat-select [(value)]="ampm" class="ampm-selector" (selectionChange)="onTimeChange($event)">
        <mat-option value="AM">AM</mat-option>
        <mat-option value="PM">PM</mat-option>
      </mat-select>
    </div>
    <mat-hint *ngIf="subtext !== ''" class="hints">
      {{subtext}}
    </mat-hint>
  </mat-form-field>

  <div *ngIf="inputType === 'file'" class="file-box" [@fadeIn]>
    <!-- For when only the file URL is available -->
    <div class="hori file" *ngIf="useFileURL" style="justify-content: space-between;">
      <div class="flex saveFileHolder" (click)="openSavedDoc()"
        (keydown.enter)="openSavedDoc()" (keydown.space)="openSavedDoc()">
        <div class="flex savedFile">
          <mat-icon *ngIf="fileURL && !fileURL.toString().toLowerCase().includes('.jpg')" fontIcon="file_open"
            aria-hidden="false" aria-label="File button">
          </mat-icon>

          <img *ngIf="fileURL && fileURL.toString().toLowerCase().includes('.jpg')"
            style="border-radius: 30px; object-fit: cover; height: 100%; width: 35px;" src={{fileURL}} alt="" />
        </div>
        <span class="savedFileText"><u>View Document</u></span>
      </div>

      <div class="flex changeImage" (click)="enableSelectImage()" (keydown.enter)="enableSelectImage()" (keydown.space)="enableSelectImage()">
        <mat-icon fontIcon="change_circle" aria-hidden="false" aria-label="File button"></mat-icon>
        <span style="margin-left: 5px;">Change</span>
      </div>
    </div>
    <!-- For normal file upload -->
    <div class="hori file" *ngIf="!useFileURL">
      <button type="button" mat-raised-button (click)="openImageModal()" class="file-button" *ngIf="!validatingFile"
        [disabled]="formControl?.disabled">
        {{ fileValid ? 'Change' : 'Select'}} <span class="file-required"
          *ngIf="required === 'true' && !fileValid">(required)</span>
      </button>

      <p class="flex file-name" [ngClass]="{'stretched': validatingFile}">
        {{fileName}}
      </p>

      <div *ngIf="validatingFile" class="flex spinner-file">
        <mat-progress-spinner mode="indeterminate" diameter="22" strokeWidth="2"></mat-progress-spinner>
      </div>
    </div>

    <div class="file-hint" *ngIf="useFileURL">
      <b style="color: #8a0000;">Uploaded from original session</b>
    </div>
    <div class="file-hint" *ngIf="!useFileURL">
      <b style="color: #8a0000;">2MB</b> size limit for <b>PDF Files</b>
    </div>

  </div>

  <form #f="ngForm" *ngIf="inputType === 'phone'" [formGroup]="formGroup" [@fadeIn]>
    <mat-form-field appearance="outline" [ngClass]="{'input': inputFocused}" style="width: 100%;">
      <ngx-mat-intl-tel-input class="country-selector" #phoneInput [preferredCountries]="['ke']"
        [enablePlaceholder]="false" [enableSearch]="true" name="phone" describedBy="phone"
        [formControlName]="controlName" (focus)="onInputFocus()" (ngModelChange)="onInputBlur()">
      </ngx-mat-intl-tel-input>
      <mat-error *ngIf="shouldShowErrors()" class="errors">
        {{ getCurrentErrorMessage() }}
      </mat-error>
    </mat-form-field>
  </form>

  <div *ngIf="inputType === 'view'" class="view-box" [@fadeIn]>
    {{hint}}
  </div>
  <div class="file-hint" *ngIf="inputType === 'view'">
    {{subtext}}
  </div>
</div>

<ng-template #modalContent>
  <div [formGroup]="formGroup" class="flex center column" style="width: 100%;" [@fadeIn] (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <!-- Action Buttons -->
    <div class="flex center" style="width: 100%; margin-bottom: 24px;">
      <button type="button" mat-raised-button (click)="pdf.click()" class="file-button" style="width: fit-content;">
        Browse
        <input [id]="controlName" type="file" [formControlName]="controlName" (change)="openImageDialog($event)" style="display: none;"
          #pdf>
      </button>

      <button type="button" mat-raised-button (click)="captureImage()" class="file-button" style="width: fit-content;">
        Take Picture
      </button>

      <button *ngIf="previewImage" type="button" mat-raised-button color="warn" (click)="removePreview()"
        style="margin-left: 16px;">
        Remove Picture
      </button>
    </div>

    <!-- Preview Section -->
    <div class="drop-zone" [class.drag-over]="isDragOver">
      <div *ngIf="previewImage" class="flex image-preview">
        <img *ngIf="isImage" [src]="previewImage" alt=""
          style="width: auto; height: 100%; object-fit: cover;">
        <!-- Show PDF if the previewImage is a PDF -->
        <iframe title="" *ngIf="!isImage" [src]="previewImage | resource"
          style="width: 100%; height: 55vh; border: none;"></iframe>
      </div>

      <div class="flex center image-preview" *ngIf="!previewImage">
        <strong>or drag and drop your file here</strong>
      </div>
    </div>

  </div>
</ng-template>